/* StalkMaster: the free beanie + neck gaiter gift follows the colour of the first set in the
   selected offer. Absolute Grey and Rock Camo have no matching kit, so they get the fallback.
   Config comes from <script type="application/json" data-sm-kit-gift> on the product page. */
(function () {
  var el = document.querySelector('script[data-sm-kit-gift]');
  if (!el) return;
  var C;
  try { C = JSON.parse(el.textContent); } catch (e) { return; }

  function colourOf(id) { return id ? C.setColours[String(id)] || null : null; }

  function slotOneVariant(offer) {
    if (!offer) return null;
    var root = offer.closest('.offers, [data-sugar-offers]');
    var ctrl = root && root.sugarOffers;
    var bid = offer.dataset.blockId;
    var v = ctrl && ctrl.selectedVariants && ctrl.selectedVariants[bid] && ctrl.selectedVariants[bid][1];
    if (colourOf(v)) return v;
    var sel = offer.querySelector('.offer__variants-slot[data-slot="1"] .offer__variant-select');
    if (sel && colourOf(sel.value)) return sel.value;
    var pill = offer.querySelector('.offer__variants-slot[data-slot="1"] .offer__variant-pill.is-active');
    if (pill && colourOf(pill.dataset.variantId)) return pill.dataset.variantId;
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : null;
  }

  function kitName(colour) {
    if (colour && C.kit[colour]) return colour;
    if (colour && C.fallback[colour] && C.kit[C.fallback[colour]]) return C.fallback[colour];
    return C.defaultColour;
  }

  function sync() {
    var gifts = document.querySelectorAll('.sugar-offer-gift[data-product-id="' + C.kitProductId + '"]');
    Array.prototype.forEach.call(gifts, function (g) {
      var offer = g.closest('.sugar-offer') || g.closest('[data-block-id]');
      var name = kitName(colourOf(slotOneVariant(offer)));
      var k = C.kit[name];
      if (!k) return;
      if (g.dataset.variantId !== String(k.id)) g.dataset.variantId = String(k.id);
      var img = g.querySelector('.sugar-offer-gift__image img');
      if (img && k.img && img.getAttribute('data-sm-src') !== k.img) {
        img.src = k.img;
        img.srcset = k.img + ' 160w';
        img.setAttribute('data-sm-src', k.img);
      }
      // Pattern name goes in the FREE tag so it never gets cut off on a phone.
      var badge = g.querySelector('.sugar-offer-gift__badge span');
      var tag = 'FREE · ' + name;
      if (badge && badge.textContent !== tag) badge.textContent = tag;
    });
  }

  // The offers controller builds the cart lines; sync right before it reads the gift rows.
  function patch() {
    var roots = document.querySelectorAll('.offers, [data-sugar-offers]');
    Array.prototype.forEach.call(roots, function (root) {
      var ctrl = root.sugarOffers;
      if (!ctrl || ctrl.__smKitGift || typeof ctrl.buildCartItems !== 'function') return;
      var original = ctrl.buildCartItems;
      ctrl.buildCartItems = function () {
        try { sync(); } catch (e) {}
        return original.apply(this, arguments);
      };
      ctrl.__smKitGift = true;
    });
  }

  function run() { try { patch(); sync(); } catch (e) {} }
  function later(ms) { return function () { setTimeout(run, ms); }; }

  document.addEventListener('variant:change', later(0));
  document.addEventListener('offers:ready', later(0));
  document.addEventListener('change', later(0), true);
  document.addEventListener('click', later(60), true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setTimeout(run, 1500);
})();
